export const nullAddress = '0x0000000000000000000000000000000000000000'
